import {
  ProjectsListGetters,
  ProjectsListActions,
  ProjectsListMutations
} from '@/app/features/projects/projects-list/projects-list.keys';
import { projectsListService } from '@/app/features/projects/projects-list/projects-list.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';

import i18n from '@/i18n';

export const getInitialState = () => {
  return {
    projectsIsLoading: true,
    projects: [],
    projectsFilteredRecordCount: 0,
    searchParam: null,
    projectsSortOrder: {
      sortBy: 'created_dt',
      sortDirection: 'desc'
    },
    projectsPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    }
  };
};

export const projectsListStore = {
  state: getInitialState(),
  getters: {
    [ProjectsListGetters.Projects]: state => {
      return state.projects;
    },
    [ProjectsListGetters.ProjectsCount]: state => {
      return state.projectsFilteredRecordCount;
    },
    [ProjectsListGetters.ProjectsIsLoading]: state => state.projectsIsLoading,
    [ProjectsListGetters.ProjectsOffset]: state => {
      return state.projectsPaginationParameters.offset;
    },
    [ProjectsListGetters.ProjectsPaginationParams]: state => {
      return state.projectsPaginationParameters;
    },
    [ProjectsListGetters.ProjectsPerPage]: state => {
      return state.projectsPaginationParameters.recordsPerPage;
    },
    [ProjectsListGetters.ProjectsSortBy]: state => {
      return state.projectsSortOrder.sortBy;
    },
    [ProjectsListGetters.ProjectsSortDirection]: state => {
      return state.projectsSortOrder.sortDirection;
    },
    [ProjectsListGetters.ProjectsSortOrder]: state => {
      return state.projectsSortOrder;
    }
  },
  actions: {
    [ProjectsListActions.FilterListBySearchKey]: ({ commit, dispatch }, params) => {
      commit(ProjectsListMutations.SetProjectsSearchParam, params.searchParam);
      if (!params.isSearchKey || !params.searchParam) {
        dispatch(ProjectsListActions.GetProjects);
      } else {
        commit(ProjectsListMutations.ResetProjectsPaginationOffset);
        commit(ProjectsListMutations.SetProjectsList, params.filteredItems);
        dispatch(ProjectsListActions.GetProjectsFilteredRecordCount);
      }
    },
    [ProjectsListActions.GetProjects]: ({ state, dispatch, commit }) => {
      commit(ProjectsListMutations.SetProjectsIsLoading);
      return projectsListService
        .getProjects(state.projectsSortOrder, state.projectsPaginationParameters, state.searchParam)
        .then(result => {
          dispatch(ProjectsListActions.GetProjectsFilteredRecordCount);
          commit(ProjectsListMutations.SetProjectsList, result);
        })
        .then(() => {
          commit(ProjectsListMutations.SetProjectsIsLoading, false);
        });
    },
    [ProjectsListActions.GetProjectsFilteredRecordCount]: ({ state, commit, dispatch }) => {
      return projectsListService
        .getFilteredRecordCount(state.searchParam)
        .then(recordCount => {
          commit(ProjectsListMutations.SetProjectsFilteredRecordCount, recordCount);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('projects.listing.errors.getProjects')
          });
          commit(ProjectsListMutations.SetProjectsIsLoading, false);
        });
    },
    [ProjectsListActions.SetProjectsFilters]: ({ commit, dispatch }, filters) => {
      commit(ProjectsListMutations.SetProjectsFilters, filters);
      commit(ProjectsListMutations.ResetProjectsPaginationOffset);
      dispatch(ProjectsListActions.GetProjects);
    },
    [ProjectsListActions.SetProjectsPaginationParameters]: ({ commit, dispatch }, pagination) => {
      commit(ProjectsListMutations.SetProjectsPaginationParameters, pagination);
      dispatch(ProjectsListActions.GetProjects);
    },
    [ProjectsListActions.SetProjectsSortOrder]: ({ commit, dispatch }, sortOrder) => {
      commit(ProjectsListMutations.SetProjectsSortOrder, sortOrder);
      commit(ProjectsListMutations.ResetProjectsPaginationOffset);
      dispatch(ProjectsListActions.GetProjects);
    }
  },
  mutations: {
    [ProjectsListMutations.ResetProjectsPaginationOffset]: state => {
      state.projectsPaginationParameters.offset = 0;
    },
    [ProjectsListMutations.SetProjectsFilteredRecordCount]: (state, recordCount) => {
      state.projectsFilteredRecordCount = recordCount;
    },
    [ProjectsListMutations.SetProjectsFilters]: (state, filters) => {
      state.projectsFilters = filters;
    },
    [ProjectsListMutations.SetProjectsIsLoading]: (state, loading = true) => {
      state.projectsIsLoading = loading;
    },
    [ProjectsListMutations.SetProjectsList]: (state, pos) => {
      state.projects = pos;
    },
    [ProjectsListMutations.SetProjectsPaginationParameters]: (state, pagination) => {
      state.projectsPaginationParameters = pagination;
    },
    [ProjectsListMutations.SetProjectsSearchParam]: (state, param) => {
      state.searchParam = param;
    },
    [ProjectsListMutations.SetProjectsSortOrder]: (state, sortOrder) => {
      state.projectsSortOrder = sortOrder;
    }
  }
};
